(() => {
  // transService.js
  const transService = {
    // 應用所有篩選條件
    classClassificationMap: {},
    airlineMap: {},
    departureMap: {
      deptEng: {
        基隆港: "KEL",
        松山: "TSA",
        桃園: "TYC",
        台中: "RMQ",
        台南: "TNN",
        高雄: "KHH",
        台北: "TPE",
        嘉義: "CYI",
        "": "TWN",
        富岡碼頭: "TMK",
        東港碼頭: "DGG",
        布袋港: "PDI",
        南港: "STP",
        中壢: "ZGL",
        豐原: "FYN",
        彰化: "CGH",
        苗栗: "MLI",
        金門: "KMN",
        澎湖: "PEH",
        花蓮: "HWA",
        台東: "TTT",
        高雄港: "KAO",
        台北港: "TPC",
      },
      AirPT: {
        中正機場第一航站: "桃園",
        中正機場第二航站: "桃園",
        台北桃園機場: "桃園",
        台灣桃園國際機場: "桃園",
        桃園國際機場: "桃園",
        松山機場: "松山",
        台北松山機場: "松山",
        台中清泉崗機場: "台中",
        台中國際機場: "台中",
        台南機場: "台南",
        高雄小港機場: "高雄",
        基隆港: "基隆港",
        嘉義機場: "嘉義",
        x: "國內",
        "": "國內",
        富岡碼頭: "富岡碼頭",
        東港碼頭: "東港碼頭",
        布袋港: "布袋港",
        高雄港: "高雄",
        台北: "台北",
        台中: "台中",
        台南: "台南",
        高雄: "高雄",
        南港: "南港",
        中壢: "中壢",
        桃園: "桃園",
        豐原: "豐原",
        彰化: "彰化",
        金門尚義機場: "金門",
        澎湖馬公機場: "澎湖",
        花蓮機場: "花蓮",
        豐年機場: "台東",
        台北港: "台北港",
      },
      AirSort: {
        基隆港: 1,
        台北: 2,
        台北港: 3,
        南港: 4,
        中壢: 5,
        松山: 6,
        桃園: 7,
        豐原: 8,
        台中: 9,
        彰化: 10,
        嘉義: 15,
        布袋港: 16,
        台南: 17,
        高雄: 18,
        國內: 19,
        富岡碼頭: 20,
        東港碼頭: 21,
        金門: 22,
        澎湖: 23,
        花蓮: 24,
        台東: 25,
        高雄港: 30,
        安平碼頭: 33,
      },
    },
    splitOpenDate(groups) {
      let result = [];

      // 遍歷每個原始的 group 對象
      groups.forEach((originalGroup) => {
        // 根據 openDate 屬性對 groups 進行分組
        const groupsByOpenDate = {};

        originalGroup.groups.forEach((groupItem) => {
          const openDate = groupItem.openDateTime;

          if (!groupsByOpenDate[openDate]) {
            groupsByOpenDate[openDate] = [];
          }

          groupsByOpenDate[openDate].push(groupItem);
        });
        if (Object.keys(groupsByOpenDate).length === 0) {
          groupsByOpenDate["載入中"] = originalGroup.groups;
        }

        // 為每個機場創建一個新的 group 對象
        Object.keys(groupsByOpenDate).forEach((openDate) => {
          // 使用解構賦值和展開運算符創建新對象
          const newGroup = {
            ...originalGroup,
            openDate: openDate, // 設置 openDate 為對應的機場
            groups: groupsByOpenDate[openDate], // 只保留對應機場的 groups
          };

          result.push(newGroup);
        });
      });
      return result;
    },
    convertAirlinesToDictionary(jsonArray) {
      const dictionary = {};
      jsonArray.forEach((item) => {
        // Add entry for classification
        const airlineKey = item.airlineCode;
        const airlineValue = item.airline;
        dictionary[airlineKey] = airlineValue;
      });
      this.airlineMap = dictionary;
      return dictionary;
    },
    transGroupStatus(jsonArray) {
      return jsonArray.map((group) => {
        group.groups = group.groups.map((groupItem) => {
          if (new Date(groupItem.orderDeadline) < new Date()) {
            groupItem.status = 1;
          } else if (groupItem.hotType === "7") {
            groupItem.status = 2;
          } else if (groupItem.remainSeat <= 0) {
            groupItem.status = 3;
          } else if (groupItem.hotType === "6") {
            groupItem.status = 5;
          } else if (groupItem.hotType === "2") {
            groupItem.status = 7;
          } else if (groupItem.hotType === "8") {
            groupItem.status = 8;
          } else {
            groupItem.status = 7;
          }
          return groupItem;
        });
        return group;
      });
    },
    transDeparture(groups, airports) {
      groups.forEach((group) => {
        group.departure =
          this.departureMap.AirPT[group.departure] || group.departure;
        if (this.departureMap.deptEng[group.departure]) {
          group.departureCode = this.departureMap.deptEng[group.departure];
        } else {
          //找不到就去airports找
          const data = airports.filter((v) => v.airpCnm == group.departure);
          if (data.length > 0) {
            group.departureCode = data[0].airpCd;
          } else {
            //如果還是沒有就給他XXX
            group.departureCode = "XXX";
          }
        }
        //group.departureCode = departureMap.deptEng[group.departure]
        group.departureSort =
          this.departureMap.AirSort[group.departure] || 9999;
      });
      return groups;
    },
    sortGroups(groups) {
      // 對 groups 陣列進行排序
      const sortGroups = [...groups].sort((a, b) => {
        // 1. 依照 departure 排序
        const departureOrderA = a.departureSort || Number.MAX_SAFE_INTEGER;
        const departureOrderB = b.departureSort || Number.MAX_SAFE_INTEGER;

        if (departureOrderA !== departureOrderB) {
          return departureOrderA - departureOrderB;
        }

        // 2. 依照 openDate 排序
        const openDateOrderA = a.openDate || Number.MAX_SAFE_INTEGER;
        const openDateOrderB = b.openDate || Number.MAX_SAFE_INTEGER;

        if (openDateOrderA !== openDateOrderB) {
          return openDateOrderA - openDateOrderB;
        }
        const minPriceA = _.min(a.groups, "sitePrice").sitePrice;
        const minPriceB = _.min(b.groups, "sitePrice").sitePrice;

        if (minPriceA !== minPriceB) {
          return minPriceA - minPriceB;
        }

        return a.orderByValue - b.orderByValue;
      });
      return sortGroups;
    },

    createGroupedStructure(data, groupShowType, sorts) {
      // 第一步：建立出發地 > 地區 > 活動 > 小分類地區的分組
      const depatureGroups = [];
      const departureMap = {};
      data = _.sortBy(data, (item) => item.orderByValue);
      const sortItems = (items) => {
        return _.sortBy(items, (item) => {
          if (sorts.date.active) {
            const date = new Date(item.groups[0]?.leaveDate);
            return sorts.date.sort === "asc" ? date : -date;
          }
          if (sorts.price.active) {
            const sitePrice = _.minBy(item.groups, "sitePrice").sitePrice;
            return sorts.price.sort === "asc" ? sitePrice : -sitePrice;
          }
          if (sorts.day.active) {
            const groupDay = _.minBy(item.groups, "groupDay").groupDay;
            return sorts.day.sort === "asc" ? groupDay : -groupDay;
          }
          return new Date(item.leaveDate);
        });
      };

      _.forEach(data, (item) => {
        const departureName = item.departure;
        const areaName = item.areaName;
        const promotionKey = item.promotion ? `${item.promotion.anchor}` : "";
        const subAreaName = item.subAreaName || "";

        let departureGroup = departureMap[departureName];
        if (!departureGroup) {
          departureGroup = {
            departureName,
            areas: [],
            areaMap: {},
          };
          departureMap[departureName] = departureGroup;
          depatureGroups.push(departureGroup);
        }

        let areaGroup = departureGroup.areaMap[areaName];
        if (!areaGroup) {
          areaGroup = {
            area: areaName,
            promotions: [],
            promotionMap: {},
          };
          departureGroup.areaMap[areaName] = areaGroup;
          departureGroup.areas.push(areaGroup);
        }

        let promotionGroup = areaGroup.promotionMap[promotionKey];
        if (!promotionGroup) {
          promotionGroup = {
            promotion: promotionKey,
            promotionData: item.promotion || null,
            subAreas: [],
            subAreaMap: {},
          };
          areaGroup.promotionMap[promotionKey] = promotionGroup;
          areaGroup.promotions.push(promotionGroup);
        }

        let subAreaGroup = promotionGroup.subAreaMap[subAreaName];
        if (!subAreaGroup) {
          subAreaGroup = {
            subAreaName,
            subOrderByValue: item.subOrderByValue ?? 9999,
            items: [],
          };
          promotionGroup.subAreaMap[subAreaName] = subAreaGroup;
          promotionGroup.subAreas.push(subAreaGroup);
        }

        subAreaGroup.items.push(item);
      });

      // 進行排序
      _.forEach(depatureGroups, (departureGroup) => {
        _.forEach(departureGroup.areas, (areaGroup) => {
          areaGroup.promotions = _.sortBy(areaGroup.promotions, (promotion) => {
            return promotion.promotionData
              ? promotion.promotionData.order
              : 9999;
          });

          _.forEach(areaGroup.promotions, (promotionGroup) => {
            promotionGroup.subAreas = _.sortBy(
              promotionGroup.subAreas,
              (subAreaGroup) => {
                return subAreaGroup.subOrderByValue ?? 9999;
              },
            );

            _.forEach(promotionGroup.subAreas, (subAreaGroup) => {
              subAreaGroup.items = sortItems(subAreaGroup.items);
            });

            delete promotionGroup.subAreaMap;
          });

          delete areaGroup.promotionMap;
        });
        delete departureGroup.areaMap;
      });

      return depatureGroups;
    },
    setPromotions(groups, promotions) {
      promotions.forEach((prom, idx) => {
        prom.order = idx + 1;
        prom.mainGroupCodes.forEach((groupCode) => {
          const group = groups.find((g) => g.mainGroupCode === groupCode);
          if (!group) return;
          group.promotion = prom;
        });
      });
      return groups;
    },
  };

  // 將服務掛載到全局
  window.transService = transService;
})();
